import { CURR_ENV } from '@/core/constants/appConfig/environment';

const WTAGDataLayerBase = 'wtagDataLayer';
const WTAGBundleNameKey = 'wtagBundleName';

export const getDatalayerBaseName = () => `${WTAGDataLayerBase}_${CURR_ENV}`;

export const getBundleNameKey = () => `${WTAGBundleNameKey}_${CURR_ENV}`;

export const getDatalayerWrapperFuncName = () => `wtag_${CURR_ENV}`;

export const WTagDataLayerBase = getDatalayerBaseName();

export const datalayerWrapperFunc = getDatalayerWrapperFuncName();
